import React from 'react'
import Link from 'gatsby-link'
import pfblogo from './pfb-logo.png'
import earth from './earth_blue_textured.png'
import arrow from './white-arrow-red-bg.png'

// Setup Intro component with state handling
const Intro = React.createClass({
  
  // Set initial state
  getInitialState: function() {
    return { 
      showSplash: true,
      hideSplash: false,
      showScreen3: false,
      showScreen4: false
    }
  },

  // State switchers
  screen2State: function() {
    this.setState({
      showSplash: false,
      hideSplash: true,
      showScreen3: false,
      showScreen4: false
    })
  },

  screen3State: function() {
    this.setState({
      showSplash: false,
      hideSplash: false,
      showScreen3: true,
      showScreen4: false
    })
  },

  screen4State: function() {
    this.setState({
      showSplash: false,
      hideSplash: false,
      showScreen3: false,
      showScreen4: true
    })
  },

  screenStateOG: function() {
    this.setState({
      showSplash: true,
      hideSplash: false,
      showScreen3: false,
      showScreen4: false
    })
  },


  // The HTML Output for the first part of the experience
  renderScreen1: function() {
    return (
      <div>
        <section className="pfb-intro-container">
          <section className="pfb-intro-earth-container">
            <img src={ earth } alt="PFB Earth Image" />
          </section>
          <section className="pfb-intro-splash-container screen-1-fade-in-text">
            <img className="pfb-intro-splash-logo" src={ pfblogo } alt="PFB Logo" />
            <div className="pfb-intro-splash-title">People for Bikes</div>
            <div className="pfb-intro-splash-subtitle">2017 Year in Review</div>
            <img onClick={ this.screen2State } className="pfb-intro-splash-arrow bounce" src={ arrow } alt="PFB 2017 Annual Report Initialization Button" />  
          </section>
          <section className="pfb-intro-container-2">
            <div className="pfb-mask-container">
            </div>
          </section>
          <div className="pfb-replay screen-1-fade-in-text">
            <Link to="/locations">Skip the Introduction</Link>
          </div>
        </section>
      </div>
    )
  },

  renderScreen2: function() {
    return (
      <div>
        <section className="pfb-intro-container">
          <section className="pfb-intro-earth-container red-to-transparent">
            <img src={ earth } alt="PFB Earth Image" className="fade-out-earth" />
          </section>
          <section className="pfb-intro-splash-container opacity-visible">
            <img className="pfb-intro-splash-logo fade-out-text" src={ pfblogo } alt="PFB Logo" />
            <div className="pfb-intro-splash-title fade-out-text">People for Bikes</div>
            <div className="pfb-intro-splash-subtitle fade-out-text">2017 Year in Review</div>
            <img onClick={ this.screen2State } className="pfb-intro-splash-arrow fade-out-earth" src={ arrow } alt="PFB 2017 Annual Report Initialization Button" />  
          </section>
          <section className="pfb-intro-container-2">
          </section>
          <section className="pfb-mask-container mask-scale">
          </section>
          <div className="pfb-mask-text-1 fade-in-text">
          Around the clock and across the nation, PeopleForBikes works in many ways to make bike riding better for everyone.
          </div>
          <img onClick={ this.screen3State } className="pfb-intro-splash-arrow-mask fade-in-arrow" src={ arrow } alt="PFB 2017 Annual Report Step 3 Button" />  
          <div className="pfb-replay opacity-visible">
            <Link to="/locations">Skip the Introduction</Link>
          </div>
        </section>
      </div>
    )
  },

  // The HTML Output for the third part of the experience
  renderScreen3: function() {
    return (
      <div>
        <section className="pfb-intro-container">
          <section className="pfb-intro-container-2 screen-3-background-hide screen-3-background-show">
          </section>
          <section className="pfb-mask-container opacity-visible">
          </section>
          <div className="pfb-mask-text-1 opacity-visible screen-3-fade-out-text">
            Around the clock and across the nation, PeopleForBikes works in many ways to make bike riding better for everyone.
          </div>
          <div className="pfb-mask-text-1 screen-3-fade-in-text">
            This year’s annual report presents a summary of our work through the lens of our travels.
          </div>
          <img onClick={ this.screen4State } className="pfb-intro-splash-arrow-mask opacity-visible" src={ arrow } alt="PFB 2017 Annual Report Step 4 Button" />  
          <div className="pfb-replay opacity-visible">
            <Link to="/locations">Skip the Introduction</Link>
          </div>
        </section>
      </div>
    )
  },

  // The HTML Output for the fourth part of the experience
  renderScreen4: function() {
    return (
      <div>
        <section className="pfb-intro-container">
          <section className="pfb-intro-container-2 pfb-intro-container-2-second-image screen-4-background-hide screen-4-background-show">
          </section>
          <section className="pfb-mask-container opacity-visible screen-4-mask-scale-out">
          </section>
          <div className="pfb-mask-text-1 opacity-visible screen-4-fade-out-main-text">
            This year’s annual report presents a summary of our work through the lens of our travels.
          </div>
          <div className="pfb-mask-text-1 screen-4-fade-in-main-text">
            We are here, there, and everywhere.
          </div>
          <img className="pfb-intro-splash-arrow-mask opacity-visible screen-4-fade-out-button" src={ arrow } alt="PFB 2017 Annual Report " />  
          <section className="pfb-waypoints-container screen-4-waypoints">
          </section>
          <Link to="/locations/">
            <div className="pfb-intro-button screen-4-fade-in-locations-button">Explore Our Work</div>
          </Link>
          <div className="pfb-replay opacity-visible screen-4-fade-out-button">
            <Link to="/locations">Skip the Introduction</Link>
          </div>
        </section>
        <div onClick={ this.screenStateOG } className="pfb-replay screen-4-fade-in-replay-intro">Replay the introduction</div>
      </div>
    )
  },

  render: function() {
    if (this.state.showSplash === true) {
      return this.renderScreen1()
    } if (this.state.hideSplash === true) {
      return this.renderScreen2()
    } if (this.state.showScreen3 === true) {
      return this.renderScreen3()
    } if (this.state.showScreen4 === true) {
      return this.renderScreen4()
    }
  }
})

export default Intro



// WEBPACK FOOTER //
// ./src/components/Intro/index.js